import { Card } from '@zorro/design-system/v2/Card';
import { Checkbox } from '@zorro/design-system/v2/Checkbox';
import { Divider } from '@zorro/design-system/v2/Divider';
import { List } from '@zorro/design-system/v2/List';
import { Box, Group, Stack, Text } from '@zorro/web/design-system';
import { useAnalytics } from '@zorro/web/shared-ui';
import { Controller, UseFormReturn } from 'react-hook-form';

import {
  CarrierApplicationSubmitFormFields,
  CheckboxChangeHandler,
} from '../CarrierCompleteStepUtils';

type Props = {
  onboardingPeriodId: string;
  requiredActions: string[];
  submissionForm: UseFormReturn<CarrierApplicationSubmitFormFields>;
};

export const CarrierApplicationCommunicationSection = ({
  onboardingPeriodId,
  requiredActions,
  submissionForm,
}: Props) => {
  const { sendEvent } = useAnalytics();
  const { control } = submissionForm;

  const createCheckboxOnChange: CheckboxChangeHandler =
    (onChange, eventName) => (event) => {
      onChange(event.target.checked);
      void sendEvent(eventName, { onboarding_period_id: onboardingPeriodId });
    };

  return (
    <Box>
      <Divider />
      <Stack mt="xl">
        <Text size="md" fw={600}>
          Send action items email
        </Text>
        <Stack gap="xs">
          <Card variant="white-border" pt="lg" px="0" pb="lg">
            <Stack gap="xs">
              <Controller
                control={control}
                name="includeApplicationInstructionsEmail"
                render={({ field: { value, onChange, ...rest } }) => (
                  <Checkbox
                    {...rest}
                    checked={value}
                    px="xl"
                    pb="sm"
                    label={
                      <Group gap="xs" align="center" wrap="nowrap">
                        <Text fw={600} size="sm">
                          Send application confirmation email with required
                          actions to employee
                        </Text>
                        <Text c="var(--color-text-default-secondary)" size="sm">
                          (sent only if at least one option is relevant)
                        </Text>
                      </Group>
                    }
                    onChange={createCheckboxOnChange(
                      onChange,
                      'include_application_instructions_email'
                    )}
                  />
                )}
              />
              {requiredActions.length > 0 && (
                <Stack gap="xxs" px="xl">
                  <Text size="sm">The actions needed for this employee:</Text>
                  <List type="ordered" size="sm">
                    {requiredActions.map((action) => (
                      <List.Item pl="xxs" key={action}>
                        {action}
                      </List.Item>
                    ))}
                  </List>
                </Stack>
              )}
            </Stack>
          </Card>
        </Stack>
      </Stack>
    </Box>
  );
};
